@let orgChartId = store.orgChartIdSg();

<div
  footer
  class="atn-summit-org-chart-node-panel-footer"
>
  <atn-ds-button
    class="atn-summit-org-chart-node-panel-footer__cancel-button"
    type="transparent"
    (click)="
      orgChartId &&
        store.orgChartFeature.actions.cancelEdits
          .from('OrgChart.EditNodeModal.Footer.CancelButton.Clicked')
          .dispatch({ orgChartId })
    "
  >
    Cancel
  </atn-ds-button>

  <atn-ds-button
    class="atn-summit-org-chart-node-panel-footer__save-button"
    (click)="
      orgChartId &&
        store.orgChartFeature.actions.saveEdits
          .from('OrgChart.EditNodeModal.Footer.SaveButton.Clicked')
          .dispatch({ orgChartId })
    "
  >
    Save
  </atn-ds-button>
</div>
